import {Component, inject, Input} from '@angular/core';
import {NavigationVisitor} from '../../../models/navigation/NavigationVisitor';
import {ErrorNavigationVisitor} from '../../../models/navigation/ErrorNavigationVisitor';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonChip,
    IonCol,
    IonGrid,
    IonRow,
    IonText
} from '@ionic/angular/standalone';
import {TranslatePipe} from '@ngx-translate/core';
import {LoggableEntity} from '../../../models/error/LoggableEntity';
import {getTimeDifferenceFromNow} from '../../../helpers/DateTimeHelpers';

@Component({
    selector: 'app-summary-card-template',
    standalone: true,
    imports: [IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonText, IonGrid, IonRow, IonCol, IonChip, TranslatePipe],
    templateUrl: './summary-card-template.component.html',
    styleUrl: './summary-card-template.component.css',
})
export class SummaryCardTemplateComponent {
    @Input({required: true}) loggableEntity!: LoggableEntity;
    @Input({required: true}) occurredDate!: Date;
    @Input({required: true}) chipNumber!: number;

    private navigationVisitor: NavigationVisitor = inject(ErrorNavigationVisitor);

    public routeToPage() {
        this.loggableEntity.accept(this.navigationVisitor);
    }

    public getErrorTimeMessage(date: Date) {
        return getTimeDifferenceFromNow(date);
    }
}
